import styled from "styled-components";
import { theme } from "@themes";

export const CreatePolicyContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .heading-label {
    font-weight: 700;
  }
  .mandatory {
    color: #ed0707;
  }
`;

export const SubPolicyModalContainer = styled.div`
  width: 80%;
  height: 80%;
  max-width: 650px;
  max-height: 600px;
  background-color: ${({ theme }) => theme.neutral.white};
  position: relative;
  height: fit-content;
`;

export const SubPolicyModalHeader = styled.div`
  margin: 10px;
  border-bottom: 2px solid ${({ theme }) => theme.neutral.gray[900]};
  label {
    font-size: 1.2rem;
    font-weight: 700;
    margin: 10px;
  }
  button {
    float: right;
  }
`;

export const LocationFieldContainer = styled.div`
  margin: 15px;
  .location-dropdown {
    margin-top: 10px;
    width: 50%;
  }
`;
export const MainPolicyContainer = styled.div`
  margin: 15px;
  display: flex;
  flex-direction: column;
  input {
    outline: none;
    border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
    padding: 10px;
    border-radius: 5px;
    margin-top: 5px;
  }
`;
export const SubPolicyContainer = styled.div`
  margin-bottom: 70px;
  .add-policy-btn {
    padding: 5px;
    border-radius: 5px;
    outline: none;
    border: 1px solid ${({ theme }) => theme.button.primaryBorder};
    background-color: ${({ theme }) => theme.neutral.white};

    span {
      margin: 5px;
      color: ${({ theme }) => theme.button.primary};
    }
  }
`;

export const SubPolicyFieldContainer = styled.div`
  display: flex;
  margin: 15px;
  justify-content: flex-end;
  padding-right: 20px;
`;
export const PolicyActionButton = styled.div`
  position: absolute;
  bottom: 0px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  button {
    margin: 15px;
    width: 130px;
    height: 30px;
    outline: none;
    border: none;
    background-color: ${({ theme }) => theme.button.primary};
    color: ${({ theme }) => theme.neutral.white};
    border-radius: 5px;
  }
`;
export const SelectStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    boxShadow: isFocused ? "#ffbbdc33" : theme.neutral.gray[700],
    borderColor: theme.neutral.gray[700],
    ":hover": {
      ...styles[":hover"],
      borderColor: "#ffbbdc33",
    },
  }),
  option: (styles, { data, isFocused }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#ffbbdc33" : data.color,
      ":hover": {
        ...styles[":hover"],
        backgroundColor: "#ffbbdc33",
      },
      color: isFocused ? theme.button.primary : data.color,
    };
  },
};

export const SubPolicies = styled.div`
  margin: 20px;
  height: 15rem;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.button.primary};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;
